import { removePropertyEmpty } from '@/utils/index'
import { Service } from '../config'
import { TYPE_OF_VEHICLES } from '@/pages/Inspection/utils/contants'

class DashboardService extends Service {
  path = 'dashboard'

  async getAveragePerDay(params: any) {
    const httpResponse = await this.httpClient.get(
      `${this.path}/customediomodelodiaspreparacao`,
      {
        params: {
          DataInicio: params?.dataInicio ? params.dataInicio : null,
          DataFim: params?.dataFim ? params.dataFim : null,
          CentroResultadoId: params?.centroResultadoId
            ? params.centroResultadoId
            : null,
          DiretoriaId: params?.diretoriaId ? params.diretoriaId : null,
          EstadoId: params?.estadoId ? params.estadoId : null,
          CidadeId: params?.cidadeId ? params.cidadeId : null
        }
      }
    )

    return httpResponse
  }

  async getCostPerHour(params: any) {
    const httpResponse = await this.httpClient.get(
      `${this.path}/customediohorapreparacao`,
      {
        params: {
          Intervalo: params?.intervalo ? params.intervalo : null,
          FaixaInicio: params?.kmInicial ? params.kmInicial : null,
          FaixaFim: params?.kmFinal ? params.kmFinal : null,
          DataInicio: params?.dataInicio ? params.dataInicio : null,
          DataFim: params?.dataFim ? params.dataFim : null,
          CentroResultadoId: params?.centroResultadoId
            ? params.centroResultadoId
            : null,
          DiretoriaId: params?.diretoriaId ? params.diretoriaId : null,
          EstadoId: params?.estadoId ? params.estadoId : null,
          CidadeId: params?.cidadeId ? params.cidadeId : null
        }
      }
    )

    return httpResponse
  }

  async getAverageKM(params: any, vehicleType: any) {
    const httpResponse = await this.httpClient.get(
      `${this.path}/customediokmpreparacao`,
      {
        params: {
          TipoVeiculo: vehicleType ?? TYPE_OF_VEHICLES[1],
          Intervalo: params?.intervalo ? params.intervalo : null,
          FaixaInicio: params?.kmInicial ? params.kmInicial : null,
          FaixaFim: params?.kmFinal ? params.kmFinal : null,
          DataInicio: params?.dataInicio ? params.dataInicio : null,
          DataFim: params?.dataFim ? params.dataFim : null,
          CentroResultadoId: params?.centroResultadoId
            ? params.centroResultadoId
            : null,
          DiretoriaId: params?.diretoriaId ? params.diretoriaId : null,
          EstadoId: params?.estadoId ? params.estadoId : null,
          CidadeId: params?.cidadeId ? params.cidadeId : null
        }
      }
    )

    return httpResponse
  }

  async getAverageCostModelExcel(params: any, vehicleType: any) {
    const httpResponse = await this.httpClient.get(
      `${this.path}/customediomodelopreparacao/excel`,
      {
        params: {
          TipoVeiculo: vehicleType ?? TYPE_OF_VEHICLES[1],
          DataInicio: params?.dataInicio ? params.dataInicio : null,
          DataFim: params?.dataFim ? params.dataFim : null,
          CentroResultadoId: params?.centroResultadoId
            ? params.centroResultadoId
            : null,
          DiretoriaId: params?.diretoriaId ? params.diretoriaId : null,
          EstadoId: params?.estadoId ? params.estadoId : null,
          CidadeId: params?.cidadeId ? params.cidadeId : null
        }
      }
    )

    return httpResponse
  }

  async getAverageCostModel(params: any, vehicleType: any) {
    const httpResponse = await this.httpClient.get(
      `${this.path}/customediomodelopreparacao`,
      {
        params: {
          TipoVeiculo: vehicleType ?? TYPE_OF_VEHICLES[1],
          DataInicio: params?.dataInicio ? params.dataInicio : null,
          DataFim: params?.dataFim ? params.dataFim : null,
          CentroResultadoId: params?.centroResultadoId
            ? params.centroResultadoId
            : null,
          DiretoriaId: params?.diretoriaId ? params.diretoriaId : null,
          EstadoId: params?.estadoId ? params.estadoId : null,
          CidadeId: params?.cidadeId ? params.cidadeId : null
        }
      }
    )

    return httpResponse
  }

  async getBudgetedRealizedValue(params: any) {
    const httpResponse = await this.httpClient.get(
      `${this.path}/customedioorcadorealizado`,
      {
        params: {
          DataInicio: params?.dataInicio ? params.dataInicio : null,
          DataFim: params?.dataFim ? params.dataFim : null,
          CentroResultadoId: params?.centroResultadoId
            ? params.centroResultadoId
            : null,
          DiretoriaId: params?.diretoriaId ? params.diretoriaId : null,
          EstadoId: params?.estadoId ? params.estadoId : null,
          CidadeId: params?.cidadeId ? params.cidadeId : null
        }
      }
    )
    return httpResponse
  }

  async getStockQuantity(params = {}) {
    const httpResponse = await this.httpClient.post(
      `${this.path}/totalestoque`,
      removePropertyEmpty(params)
    )
    return httpResponse
  }

  async getSurvayTotal(params = {}) {
    const httpResponse = await this.httpClient.post(
      `${this.path}/totalvistoriascadastradas`,
      removePropertyEmpty(params)
    )
    return httpResponse
  }

  async getTotalBreakdownInspection(params?: any) {
    const httpResponse = await this.httpClient.get(
      `${this.path}/totalvistoriasavarias`,
      {
        params: removePropertyEmpty(params),
        paramsSerializer: (params) => {
          const [key] = Object.keys(params)
          const [values]: any = Object.values(params)
          const searchParams = values.map((value: string) => ({ [key]: value }))

          return searchParams
            .map((keyValuePair: any) => new URLSearchParams(keyValuePair))
            .join('&')
        }
      }
    )
    return httpResponse
  }
}

export const dashboardService = new DashboardService()
